/**
 * Static field/table configuration used by `useOfferingHooks`.
 * Pure functions — no React state.
 */

export interface OfferingFieldConfig {
  label: string;
  type: "text";
  sortable: true;
  filterable: true;
  resizable: true;
  hideable: true;
  editable: true;
  formSpan: 1;
  width: 150;
  minWidth: 100;
  maxWidth: 300;
}

export interface OfferingTableConfig {
  entity: "offerings";
  displayName: "Offerings";
  fields: Record<string, never>;
}

export function getOfferingFieldConfig(fieldName: string): OfferingFieldConfig {
  return {
    label: fieldName,
    type: "text",
    sortable: true,
    filterable: true,
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 1,
    width: 150,
    minWidth: 100,
    maxWidth: 300,
  };
}

export function getOfferingTableConfig(): OfferingTableConfig {
  return {
    entity: "offerings",
    displayName: "Offerings",
    fields: {},
  };
}
